export function inspectPropertiesAction() {
  const { t } = useI18n();
  const viewerStore = useViewerStore();

  return {
    title: t('components.xeokit_viewer.context_menu.inspect_properties') || 'Inspect Properties',

    getShown(context) {
      return !!context.entity?.isObject;
    },
    doAction: (context) => {
      const objectId = context.entity.id;
      context.entity.selected = true;
      viewerStore.showObjectProperties(objectId);
    },
  };
}
